import { default as index9bDZRAPqycMeta } from "/app/pages/booksummarySitemap/index.vue?macro=true";
import { default as AdditionalQWxYlpfbCCMeta } from "/app/pages/calculator/components/Additional.vue?macro=true";
import { default as CalculatormwxOjzU2H7Meta } from "/app/pages/calculator/components/Calculator.vue?macro=true";
import { default as FaqsJpeiq30KMIMeta } from "/app/pages/calculator/components/Faqs.vue?macro=true";
import { default as KeyboardItemWxvCvIElifMeta } from "/app/pages/calculator/components/KeyboardItem.vue?macro=true";
import { default as ResultIUKo2BAUzUMeta } from "/app/pages/calculator/components/Result.vue?macro=true";
import { default as second_45partKsZuZIrIf0Meta } from "/app/pages/calculator/components/second-part.vue?macro=true";
import { default as indexkxyY8g7iSHMeta } from "/app/pages/calculator/index.vue?macro=true";
import { default as indexmej5UkIwuvMeta } from "/app/pages/essays/index.vue?macro=true";
import { default as indexb883eddeK7Meta } from "/app/pages/essaysDetail/index.vue?macro=true";
import { default as index2zJBTchzUHMeta } from "/app/pages/essaysitemap/index.vue?macro=true";
import { default as indexQbJ55MVosxMeta } from "/app/pages/knowledge/details/index.vue?macro=true";
import { default as subject_45selectQfXsj0cCXrMeta } from "/app/pages/knowledge/list/components/subject-select.vue?macro=true";
import { default as indexceZjO7RgKKMeta } from "/app/pages/knowledge/list/index.vue?macro=true";
import { default as indexl3OPEX62vMMeta } from "/app/pages/knowledgesitemap/index.vue?macro=true";
import { default as knowledge_45related8NW9VSr4MoMeta } from "/app/pages/questions/components/knowledge-related.vue?macro=true";
import { default as live_45tutoreZONoJy6NNMeta } from "/app/pages/questions/components/live-tutor.vue?macro=true";
import { default as video_45covereUCX4t7slAMeta } from "/app/pages/questions/components/video-cover.vue?macro=true";
import { default as indexgmNSdukx58Meta } from "/app/pages/questions/index.vue?macro=true";
import { default as indexRVFBNb9ASCMeta } from "/app/pages/questionsno/index.vue?macro=true";
import { default as indexBV1zPX3VR7Meta } from "/app/pages/sitemap/index.vue?macro=true";
import { default as indexIpovj53zUGMeta } from "/app/pages/subject/index.vue?macro=true";
import { default as itemHMkKCfQwrCMeta } from "/app/pages/subjects/components/item.vue?macro=true";
import { default as part_45evaluategny7rSIa7OMeta } from "/app/pages/subjects/components/part-evaluate.vue?macro=true";
import { default as videoaScQT16v1mMeta } from "/app/pages/subjects/components/video.vue?macro=true";
import { default as indexs3b7HPfTVyMeta } from "/app/pages/subjects/index.vue?macro=true";
import { default as indexHZBIitQYz8Meta } from "/app/pages/textbook-answer/components/detail-book-profile/index.vue?macro=true";
import { default as indexfHuuGYfZ40Meta } from "/app/pages/textbook-answer/components/detail-breadcrumbs-header/index.vue?macro=true";
import { default as index8ZLuE61FIgMeta } from "/app/pages/textbook-answer/components/detail-chapter-list/index.vue?macro=true";
import { default as index9ab3lcJZoRMeta } from "/app/pages/textbook-answer/components/detail-content/index.vue?macro=true";
import { default as indexoizCcKrNyXMeta } from "/app/pages/textbook-answer/components/detail-right-anchor-list/index.vue?macro=true";
import { default as indexq2B32DIaeyMeta } from "/app/pages/textbook-answer/components/detail-search-bar/index.vue?macro=true";
import { default as index1Eeylpd6ZuMeta } from "/app/pages/textbook-answer/index.vue?macro=true";
import { default as book_45relatedFIvT2s9UuYMeta } from "/app/pages/textbook-chapter/components/book-related.vue?macro=true";
import { default as index49PSRXLLefMeta } from "/app/pages/textbook-chapter/index.vue?macro=true";
import { default as book_45itemtjLME1dfA9Meta } from "/app/pages/textbook-list/components/book-item.vue?macro=true";
import { default as common_45content2gZquwRkaRMeta } from "/app/pages/textbook-list/components/common-content.vue?macro=true";
import { default as highlight_45keyword_45contentcUMINSjZirMeta } from "/app/pages/textbook-list/components/highlight-keyword-content.vue?macro=true";
import { default as indexDoEwHHZT6NMeta } from "/app/pages/textbook-list/components/home-list-empty-placeholder/index.vue?macro=true";
import { default as indexB6ai8mJBKxMeta } from "/app/pages/textbook-list/components/home-subject-nav/index.vue?macro=true";
import { default as QuestionMarkHoveringIconMe3MneHFylMeta } from "/app/pages/textbook-list/components/QuestionMarkHoveringIcon.vue?macro=true";
import { default as QuestionMarkIconsqWcyNaXLgMeta } from "/app/pages/textbook-list/components/QuestionMarkIcon.vue?macro=true";
import { default as indexqSLXWpwGumMeta } from "/app/pages/textbook-list/components/search-bar/index.vue?macro=true";
import { default as indexubjMxd5xoVMeta } from "/app/pages/textbook-list/explorer/index.vue?macro=true";
import { default as indexw07V8XyqSTMeta } from "/app/pages/textbook-list/index.vue?macro=true";
import { default as indexH77EFnCVSDMeta } from "/app/pages/textbook-list/search/index.vue?macro=true";
import { default as indexZI5uVrXrzPMeta } from "/app/pages/textbooksolutionSitemap/index.vue?macro=true";
export default [
  {
    name: index9bDZRAPqycMeta?.name ?? "booksummarySitemap",
    path: index9bDZRAPqycMeta?.path ?? "/booksummarySitemap",
    meta: index9bDZRAPqycMeta || {},
    alias: index9bDZRAPqycMeta?.alias || [],
    redirect: index9bDZRAPqycMeta?.redirect || undefined,
    component: () => import("/app/pages/booksummarySitemap/index.vue").then(m => m.default || m)
  },
  {
    name: AdditionalQWxYlpfbCCMeta?.name ?? "calculator-components-Additional",
    path: AdditionalQWxYlpfbCCMeta?.path ?? "/calculator/components/Additional",
    meta: AdditionalQWxYlpfbCCMeta || {},
    alias: AdditionalQWxYlpfbCCMeta?.alias || [],
    redirect: AdditionalQWxYlpfbCCMeta?.redirect || undefined,
    component: () => import("/app/pages/calculator/components/Additional.vue").then(m => m.default || m)
  },
  {
    name: CalculatormwxOjzU2H7Meta?.name ?? "calculator-components-Calculator",
    path: CalculatormwxOjzU2H7Meta?.path ?? "/calculator/components/Calculator",
    meta: CalculatormwxOjzU2H7Meta || {},
    alias: CalculatormwxOjzU2H7Meta?.alias || [],
    redirect: CalculatormwxOjzU2H7Meta?.redirect || undefined,
    component: () => import("/app/pages/calculator/components/Calculator.vue").then(m => m.default || m)
  },
  {
    name: FaqsJpeiq30KMIMeta?.name ?? "calculator-components-Faqs",
    path: FaqsJpeiq30KMIMeta?.path ?? "/calculator/components/Faqs",
    meta: FaqsJpeiq30KMIMeta || {},
    alias: FaqsJpeiq30KMIMeta?.alias || [],
    redirect: FaqsJpeiq30KMIMeta?.redirect || undefined,
    component: () => import("/app/pages/calculator/components/Faqs.vue").then(m => m.default || m)
  },
  {
    name: KeyboardItemWxvCvIElifMeta?.name ?? "calculator-components-KeyboardItem",
    path: KeyboardItemWxvCvIElifMeta?.path ?? "/calculator/components/KeyboardItem",
    meta: KeyboardItemWxvCvIElifMeta || {},
    alias: KeyboardItemWxvCvIElifMeta?.alias || [],
    redirect: KeyboardItemWxvCvIElifMeta?.redirect || undefined,
    component: () => import("/app/pages/calculator/components/KeyboardItem.vue").then(m => m.default || m)
  },
  {
    name: ResultIUKo2BAUzUMeta?.name ?? "calculator-components-Result",
    path: ResultIUKo2BAUzUMeta?.path ?? "/calculator/components/Result",
    meta: ResultIUKo2BAUzUMeta || {},
    alias: ResultIUKo2BAUzUMeta?.alias || [],
    redirect: ResultIUKo2BAUzUMeta?.redirect || undefined,
    component: () => import("/app/pages/calculator/components/Result.vue").then(m => m.default || m)
  },
  {
    name: second_45partKsZuZIrIf0Meta?.name ?? "calculator-components-second-part",
    path: second_45partKsZuZIrIf0Meta?.path ?? "/calculator/components/second-part",
    meta: second_45partKsZuZIrIf0Meta || {},
    alias: second_45partKsZuZIrIf0Meta?.alias || [],
    redirect: second_45partKsZuZIrIf0Meta?.redirect || undefined,
    component: () => import("/app/pages/calculator/components/second-part.vue").then(m => m.default || m)
  },
  {
    name: indexkxyY8g7iSHMeta?.name ?? "calculator",
    path: indexkxyY8g7iSHMeta?.path ?? "/calculator",
    meta: indexkxyY8g7iSHMeta || {},
    alias: indexkxyY8g7iSHMeta?.alias || [],
    redirect: indexkxyY8g7iSHMeta?.redirect || undefined,
    component: () => import("/app/pages/calculator/index.vue").then(m => m.default || m)
  },
  {
    name: indexmej5UkIwuvMeta?.name ?? "essays",
    path: indexmej5UkIwuvMeta?.path ?? "/essays",
    meta: indexmej5UkIwuvMeta || {},
    alias: indexmej5UkIwuvMeta?.alias || [],
    redirect: indexmej5UkIwuvMeta?.redirect || undefined,
    component: () => import("/app/pages/essays/index.vue").then(m => m.default || m)
  },
  {
    name: indexb883eddeK7Meta?.name ?? "essaysDetail",
    path: indexb883eddeK7Meta?.path ?? "/essaysDetail",
    meta: indexb883eddeK7Meta || {},
    alias: indexb883eddeK7Meta?.alias || [],
    redirect: indexb883eddeK7Meta?.redirect || undefined,
    component: () => import("/app/pages/essaysDetail/index.vue").then(m => m.default || m)
  },
  {
    name: index2zJBTchzUHMeta?.name ?? "essaysitemap",
    path: index2zJBTchzUHMeta?.path ?? "/essaysitemap",
    meta: index2zJBTchzUHMeta || {},
    alias: index2zJBTchzUHMeta?.alias || [],
    redirect: index2zJBTchzUHMeta?.redirect || undefined,
    component: () => import("/app/pages/essaysitemap/index.vue").then(m => m.default || m)
  },
  {
    name: indexQbJ55MVosxMeta?.name ?? "knowledge-details",
    path: indexQbJ55MVosxMeta?.path ?? "/knowledge/details",
    meta: indexQbJ55MVosxMeta || {},
    alias: indexQbJ55MVosxMeta?.alias || [],
    redirect: indexQbJ55MVosxMeta?.redirect || undefined,
    component: () => import("/app/pages/knowledge/details/index.vue").then(m => m.default || m)
  },
  {
    name: subject_45selectQfXsj0cCXrMeta?.name ?? "knowledge-list-components-subject-select",
    path: subject_45selectQfXsj0cCXrMeta?.path ?? "/knowledge/list/components/subject-select",
    meta: subject_45selectQfXsj0cCXrMeta || {},
    alias: subject_45selectQfXsj0cCXrMeta?.alias || [],
    redirect: subject_45selectQfXsj0cCXrMeta?.redirect || undefined,
    component: () => import("/app/pages/knowledge/list/components/subject-select.vue").then(m => m.default || m)
  },
  {
    name: indexceZjO7RgKKMeta?.name ?? "knowledge-list",
    path: indexceZjO7RgKKMeta?.path ?? "/knowledge/list",
    meta: indexceZjO7RgKKMeta || {},
    alias: indexceZjO7RgKKMeta?.alias || [],
    redirect: indexceZjO7RgKKMeta?.redirect || undefined,
    component: () => import("/app/pages/knowledge/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexl3OPEX62vMMeta?.name ?? "knowledgesitemap",
    path: indexl3OPEX62vMMeta?.path ?? "/knowledgesitemap",
    meta: indexl3OPEX62vMMeta || {},
    alias: indexl3OPEX62vMMeta?.alias || [],
    redirect: indexl3OPEX62vMMeta?.redirect || undefined,
    component: () => import("/app/pages/knowledgesitemap/index.vue").then(m => m.default || m)
  },
  {
    name: knowledge_45related8NW9VSr4MoMeta?.name ?? "questions-components-knowledge-related",
    path: knowledge_45related8NW9VSr4MoMeta?.path ?? "/questions/components/knowledge-related",
    meta: knowledge_45related8NW9VSr4MoMeta || {},
    alias: knowledge_45related8NW9VSr4MoMeta?.alias || [],
    redirect: knowledge_45related8NW9VSr4MoMeta?.redirect || undefined,
    component: () => import("/app/pages/questions/components/knowledge-related.vue").then(m => m.default || m)
  },
  {
    name: live_45tutoreZONoJy6NNMeta?.name ?? "questions-components-live-tutor",
    path: live_45tutoreZONoJy6NNMeta?.path ?? "/questions/components/live-tutor",
    meta: live_45tutoreZONoJy6NNMeta || {},
    alias: live_45tutoreZONoJy6NNMeta?.alias || [],
    redirect: live_45tutoreZONoJy6NNMeta?.redirect || undefined,
    component: () => import("/app/pages/questions/components/live-tutor.vue").then(m => m.default || m)
  },
  {
    name: video_45covereUCX4t7slAMeta?.name ?? "questions-components-video-cover",
    path: video_45covereUCX4t7slAMeta?.path ?? "/questions/components/video-cover",
    meta: video_45covereUCX4t7slAMeta || {},
    alias: video_45covereUCX4t7slAMeta?.alias || [],
    redirect: video_45covereUCX4t7slAMeta?.redirect || undefined,
    component: () => import("/app/pages/questions/components/video-cover.vue").then(m => m.default || m)
  },
  {
    name: indexgmNSdukx58Meta?.name ?? "questions",
    path: indexgmNSdukx58Meta?.path ?? "/questions",
    meta: indexgmNSdukx58Meta || {},
    alias: indexgmNSdukx58Meta?.alias || [],
    redirect: indexgmNSdukx58Meta?.redirect || undefined,
    component: () => import("/app/pages/questions/index.vue").then(m => m.default || m)
  },
  {
    name: indexRVFBNb9ASCMeta?.name ?? "questionsno",
    path: indexRVFBNb9ASCMeta?.path ?? "/questionsno",
    meta: indexRVFBNb9ASCMeta || {},
    alias: indexRVFBNb9ASCMeta?.alias || [],
    redirect: indexRVFBNb9ASCMeta?.redirect || undefined,
    component: () => import("/app/pages/questionsno/index.vue").then(m => m.default || m)
  },
  {
    name: indexBV1zPX3VR7Meta?.name ?? "sitemap",
    path: indexBV1zPX3VR7Meta?.path ?? "/sitemap",
    meta: indexBV1zPX3VR7Meta || {},
    alias: indexBV1zPX3VR7Meta?.alias || [],
    redirect: indexBV1zPX3VR7Meta?.redirect || undefined,
    component: () => import("/app/pages/sitemap/index.vue").then(m => m.default || m)
  },
  {
    name: indexIpovj53zUGMeta?.name ?? "subject",
    path: indexIpovj53zUGMeta?.path ?? "/subject",
    meta: indexIpovj53zUGMeta || {},
    alias: indexIpovj53zUGMeta?.alias || [],
    redirect: indexIpovj53zUGMeta?.redirect || undefined,
    component: () => import("/app/pages/subject/index.vue").then(m => m.default || m)
  },
  {
    name: itemHMkKCfQwrCMeta?.name ?? "subjects-components-item",
    path: itemHMkKCfQwrCMeta?.path ?? "/subjects/components/item",
    meta: itemHMkKCfQwrCMeta || {},
    alias: itemHMkKCfQwrCMeta?.alias || [],
    redirect: itemHMkKCfQwrCMeta?.redirect || undefined,
    component: () => import("/app/pages/subjects/components/item.vue").then(m => m.default || m)
  },
  {
    name: part_45evaluategny7rSIa7OMeta?.name ?? "subjects-components-part-evaluate",
    path: part_45evaluategny7rSIa7OMeta?.path ?? "/subjects/components/part-evaluate",
    meta: part_45evaluategny7rSIa7OMeta || {},
    alias: part_45evaluategny7rSIa7OMeta?.alias || [],
    redirect: part_45evaluategny7rSIa7OMeta?.redirect || undefined,
    component: () => import("/app/pages/subjects/components/part-evaluate.vue").then(m => m.default || m)
  },
  {
    name: videoaScQT16v1mMeta?.name ?? "subjects-components-video",
    path: videoaScQT16v1mMeta?.path ?? "/subjects/components/video",
    meta: videoaScQT16v1mMeta || {},
    alias: videoaScQT16v1mMeta?.alias || [],
    redirect: videoaScQT16v1mMeta?.redirect || undefined,
    component: () => import("/app/pages/subjects/components/video.vue").then(m => m.default || m)
  },
  {
    name: indexs3b7HPfTVyMeta?.name ?? "subjects",
    path: indexs3b7HPfTVyMeta?.path ?? "/subjects",
    meta: indexs3b7HPfTVyMeta || {},
    alias: indexs3b7HPfTVyMeta?.alias || [],
    redirect: indexs3b7HPfTVyMeta?.redirect || undefined,
    component: () => import("/app/pages/subjects/index.vue").then(m => m.default || m)
  },
  {
    name: indexHZBIitQYz8Meta?.name ?? "textbook-answer-components-detail-book-profile",
    path: indexHZBIitQYz8Meta?.path ?? "/textbook-answer/components/detail-book-profile",
    meta: indexHZBIitQYz8Meta || {},
    alias: indexHZBIitQYz8Meta?.alias || [],
    redirect: indexHZBIitQYz8Meta?.redirect || undefined,
    component: () => import("/app/pages/textbook-answer/components/detail-book-profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexfHuuGYfZ40Meta?.name ?? "textbook-answer-components-detail-breadcrumbs-header",
    path: indexfHuuGYfZ40Meta?.path ?? "/textbook-answer/components/detail-breadcrumbs-header",
    meta: indexfHuuGYfZ40Meta || {},
    alias: indexfHuuGYfZ40Meta?.alias || [],
    redirect: indexfHuuGYfZ40Meta?.redirect || undefined,
    component: () => import("/app/pages/textbook-answer/components/detail-breadcrumbs-header/index.vue").then(m => m.default || m)
  },
  {
    name: index8ZLuE61FIgMeta?.name ?? "textbook-answer-components-detail-chapter-list",
    path: index8ZLuE61FIgMeta?.path ?? "/textbook-answer/components/detail-chapter-list",
    meta: index8ZLuE61FIgMeta || {},
    alias: index8ZLuE61FIgMeta?.alias || [],
    redirect: index8ZLuE61FIgMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-answer/components/detail-chapter-list/index.vue").then(m => m.default || m)
  },
  {
    name: index9ab3lcJZoRMeta?.name ?? "textbook-answer-components-detail-content",
    path: index9ab3lcJZoRMeta?.path ?? "/textbook-answer/components/detail-content",
    meta: index9ab3lcJZoRMeta || {},
    alias: index9ab3lcJZoRMeta?.alias || [],
    redirect: index9ab3lcJZoRMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-answer/components/detail-content/index.vue").then(m => m.default || m)
  },
  {
    name: indexoizCcKrNyXMeta?.name ?? "textbook-answer-components-detail-right-anchor-list",
    path: indexoizCcKrNyXMeta?.path ?? "/textbook-answer/components/detail-right-anchor-list",
    meta: indexoizCcKrNyXMeta || {},
    alias: indexoizCcKrNyXMeta?.alias || [],
    redirect: indexoizCcKrNyXMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-answer/components/detail-right-anchor-list/index.vue").then(m => m.default || m)
  },
  {
    name: indexq2B32DIaeyMeta?.name ?? "textbook-answer-components-detail-search-bar",
    path: indexq2B32DIaeyMeta?.path ?? "/textbook-answer/components/detail-search-bar",
    meta: indexq2B32DIaeyMeta || {},
    alias: indexq2B32DIaeyMeta?.alias || [],
    redirect: indexq2B32DIaeyMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-answer/components/detail-search-bar/index.vue").then(m => m.default || m)
  },
  {
    name: index1Eeylpd6ZuMeta?.name ?? "textbook-answer",
    path: index1Eeylpd6ZuMeta?.path ?? "/textbook-answer",
    meta: index1Eeylpd6ZuMeta || {},
    alias: index1Eeylpd6ZuMeta?.alias || [],
    redirect: index1Eeylpd6ZuMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-answer/index.vue").then(m => m.default || m)
  },
  {
    name: book_45relatedFIvT2s9UuYMeta?.name ?? "textbook-chapter-components-book-related",
    path: book_45relatedFIvT2s9UuYMeta?.path ?? "/textbook-chapter/components/book-related",
    meta: book_45relatedFIvT2s9UuYMeta || {},
    alias: book_45relatedFIvT2s9UuYMeta?.alias || [],
    redirect: book_45relatedFIvT2s9UuYMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-chapter/components/book-related.vue").then(m => m.default || m)
  },
  {
    name: index49PSRXLLefMeta?.name ?? "textbook-chapter",
    path: index49PSRXLLefMeta?.path ?? "/textbook-chapter",
    meta: index49PSRXLLefMeta || {},
    alias: index49PSRXLLefMeta?.alias || [],
    redirect: index49PSRXLLefMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-chapter/index.vue").then(m => m.default || m)
  },
  {
    name: book_45itemtjLME1dfA9Meta?.name ?? "textbook-list-components-book-item",
    path: book_45itemtjLME1dfA9Meta?.path ?? "/textbook-list/components/book-item",
    meta: book_45itemtjLME1dfA9Meta || {},
    alias: book_45itemtjLME1dfA9Meta?.alias || [],
    redirect: book_45itemtjLME1dfA9Meta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/book-item.vue").then(m => m.default || m)
  },
  {
    name: common_45content2gZquwRkaRMeta?.name ?? "textbook-list-components-common-content",
    path: common_45content2gZquwRkaRMeta?.path ?? "/textbook-list/components/common-content",
    meta: common_45content2gZquwRkaRMeta || {},
    alias: common_45content2gZquwRkaRMeta?.alias || [],
    redirect: common_45content2gZquwRkaRMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/common-content.vue").then(m => m.default || m)
  },
  {
    name: highlight_45keyword_45contentcUMINSjZirMeta?.name ?? "textbook-list-components-highlight-keyword-content",
    path: highlight_45keyword_45contentcUMINSjZirMeta?.path ?? "/textbook-list/components/highlight-keyword-content",
    meta: highlight_45keyword_45contentcUMINSjZirMeta || {},
    alias: highlight_45keyword_45contentcUMINSjZirMeta?.alias || [],
    redirect: highlight_45keyword_45contentcUMINSjZirMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/highlight-keyword-content.vue").then(m => m.default || m)
  },
  {
    name: indexDoEwHHZT6NMeta?.name ?? "textbook-list-components-home-list-empty-placeholder",
    path: indexDoEwHHZT6NMeta?.path ?? "/textbook-list/components/home-list-empty-placeholder",
    meta: indexDoEwHHZT6NMeta || {},
    alias: indexDoEwHHZT6NMeta?.alias || [],
    redirect: indexDoEwHHZT6NMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/home-list-empty-placeholder/index.vue").then(m => m.default || m)
  },
  {
    name: indexB6ai8mJBKxMeta?.name ?? "textbook-list-components-home-subject-nav",
    path: indexB6ai8mJBKxMeta?.path ?? "/textbook-list/components/home-subject-nav",
    meta: indexB6ai8mJBKxMeta || {},
    alias: indexB6ai8mJBKxMeta?.alias || [],
    redirect: indexB6ai8mJBKxMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/home-subject-nav/index.vue").then(m => m.default || m)
  },
  {
    name: QuestionMarkHoveringIconMe3MneHFylMeta?.name ?? "textbook-list-components-QuestionMarkHoveringIcon",
    path: QuestionMarkHoveringIconMe3MneHFylMeta?.path ?? "/textbook-list/components/QuestionMarkHoveringIcon",
    meta: QuestionMarkHoveringIconMe3MneHFylMeta || {},
    alias: QuestionMarkHoveringIconMe3MneHFylMeta?.alias || [],
    redirect: QuestionMarkHoveringIconMe3MneHFylMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/QuestionMarkHoveringIcon.vue").then(m => m.default || m)
  },
  {
    name: QuestionMarkIconsqWcyNaXLgMeta?.name ?? "textbook-list-components-QuestionMarkIcon",
    path: QuestionMarkIconsqWcyNaXLgMeta?.path ?? "/textbook-list/components/QuestionMarkIcon",
    meta: QuestionMarkIconsqWcyNaXLgMeta || {},
    alias: QuestionMarkIconsqWcyNaXLgMeta?.alias || [],
    redirect: QuestionMarkIconsqWcyNaXLgMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/QuestionMarkIcon.vue").then(m => m.default || m)
  },
  {
    name: indexqSLXWpwGumMeta?.name ?? "textbook-list-components-search-bar",
    path: indexqSLXWpwGumMeta?.path ?? "/textbook-list/components/search-bar",
    meta: indexqSLXWpwGumMeta || {},
    alias: indexqSLXWpwGumMeta?.alias || [],
    redirect: indexqSLXWpwGumMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/components/search-bar/index.vue").then(m => m.default || m)
  },
  {
    name: indexubjMxd5xoVMeta?.name ?? "textbook-list-explorer",
    path: indexubjMxd5xoVMeta?.path ?? "/textbook-list/explorer",
    meta: indexubjMxd5xoVMeta || {},
    alias: indexubjMxd5xoVMeta?.alias || [],
    redirect: indexubjMxd5xoVMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/explorer/index.vue").then(m => m.default || m)
  },
  {
    name: indexw07V8XyqSTMeta?.name ?? "textbook-list",
    path: indexw07V8XyqSTMeta?.path ?? "/textbook-list",
    meta: indexw07V8XyqSTMeta || {},
    alias: indexw07V8XyqSTMeta?.alias || [],
    redirect: indexw07V8XyqSTMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/index.vue").then(m => m.default || m)
  },
  {
    name: indexH77EFnCVSDMeta?.name ?? "textbook-list-search",
    path: indexH77EFnCVSDMeta?.path ?? "/textbook-list/search",
    meta: indexH77EFnCVSDMeta || {},
    alias: indexH77EFnCVSDMeta?.alias || [],
    redirect: indexH77EFnCVSDMeta?.redirect || undefined,
    component: () => import("/app/pages/textbook-list/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexZI5uVrXrzPMeta?.name ?? "textbooksolutionSitemap",
    path: indexZI5uVrXrzPMeta?.path ?? "/textbooksolutionSitemap",
    meta: indexZI5uVrXrzPMeta || {},
    alias: indexZI5uVrXrzPMeta?.alias || [],
    redirect: indexZI5uVrXrzPMeta?.redirect || undefined,
    component: () => import("/app/pages/textbooksolutionSitemap/index.vue").then(m => m.default || m)
  }
]